import moment from "moment";

import { differenceOfDaysFromToday } from "lib/date";
import { useAppConfigs } from "services/appConfigs";
import {
  FALLBACK_ACTIVE_OWNER_THRESHOLD,
  FALLBACK_RECENT_LISTING_THRESHOLD,
} from "services/appConfigs/constants";

export const useListingInfos = (
  publishedDate: string,
  ownerLastActiveDate: string,
) => {
  const appConfigsQueries = useAppConfigs([
    "ACTIVE_OWNER_THRESHOLD",
    "RECENT_LISTING_THRESHOLD",
  ]);

  const activeOwnerThreshold =
    moment.duration(appConfigsQueries.data?.ACTIVE_OWNER_THRESHOLD).asDays() ||
    FALLBACK_ACTIVE_OWNER_THRESHOLD;

  const newListingThreshold =
    moment
      .duration(appConfigsQueries.data?.RECENT_LISTING_THRESHOLD)
      .asDays() || FALLBACK_RECENT_LISTING_THRESHOLD;

  const isNewListing =
    differenceOfDaysFromToday(publishedDate) <= newListingThreshold;

  const isActiveOwner =
    differenceOfDaysFromToday(ownerLastActiveDate) <= activeOwnerThreshold;

  return [isNewListing, isActiveOwner];
};
